const polls = [
	{
		path: '/network/polls/list',
		name: 'network-polls-list',
		component: () => import('@/views/network/polls/list.vue'),
		meta: { layout: 'content', module: 'MGN,polls' },
	},
	{
		path: '/network/polls/new',
		name: 'network-polls-create',
		component: () => import('@/views/network/polls/form.vue'),
		meta: { layout: 'content', module: 'MGN,polls' },
	},
	{
		path: '/network/polls/edit/:uuid',
		name: 'network-polls-edit',
		component: () => import('@/views/network/polls/form.vue'),
		meta: { layout: 'content', module: 'MGN,polls' },
	},
	{
		path: '/network/polls/categories',
		name: 'network-polls-categories',
		component: () => import('@/views/network/polls/categories.vue'),
		meta: { layout: 'content', module: 'MGN,polls' },
	},
]

export default polls
